import React from "react";

const DateSection = (props) => {
  const parseDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString.replace(" ", "T"));
      const timeString = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      return "Selected Time: " + timeString;
    }
    return " ";
  };

  return (
    <div style={{ display: "flex", alignItems: "left" }}>
      <div
        style={{ display: "flex", flexDirection: "column", alignItems: props.mode === "remove" ? "left" : "center" }}
      >
        <div style={{ display: "flex", flexDirection: "column", width: "250px" }}>
          Effective Date
          <input
            type="date"
            className="date-input form-control"
            onChange={(e) => {
              props.onCalendarClick(e.target.value);
            }}
            value={props.user && props.user.effectiveDate ? props.dateTimeOnCalendarInput.dateToShow : ""}
            style={{
              width: "100%",
              border: "1px solid #CED4DA",
              borderRadius: "5px",
              paddingLeft: "10px",
            }}
          />
        </div>
        <div>{parseDateString(props.user ? props.user.effectiveDate : "")}</div>
      </div>
    </div>
  );
};

export default DateSection;
